import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import "./Player.css";
import axios from "axios";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import Select from "react-select";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import { toast } from "react-toastify";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";


function Player({ onlyPermission, ...props }) {
  const { fetchRequest, globalImageUplaodAPI } = useMyContext()
  const [playerData, setPlayerData] = useState(null);
  const [activeTab, setActiveTab] = useState("horizontal");
  const [fileName, setFileName] = useState(null);
  const [fileNameplayer_thumbnail, setFileNameplayer_thumbnail] = useState(null);
  const [fileNamePlayerLogo, setFileNamePlayerLogo] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewImageplayer_thumbnail, setPreviewImageplayer_thumbnail] = useState(null);
  const [previewImagePlayerLogo, setPreviewImagePlayerLogo] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [watermarkLogoError, setWatermarkLogoError] = useState('');
  const [playerThumbnailError, setPlayerThumbnailError] = useState('');
  const [playerLogoError, setPlayerLogoError] = useState('');
  const [errors, setErrors] = useState({});
  const navigationOptions = [
    { value: "arrow", name: "Arrow" },
    { value: "chevron", name: "Chevron" },
    { value: "close", name: "Close" },
  ];

  const [optionsshow_speed_control, setOptionsshow_speed_control] = useState([]);
  const [selectedValuesspeed_control, setSelectedValuesspeed_control] = useState([]);
  const handleSelectChangespeed_control = (selectedOptionsspeed_control) => {
    setSelectedValuesspeed_control(selectedOptionsspeed_control);
  };
  const [optionscontrols, setOptionscontrols] = useState([]);
  const [selectedValuescontrols_controls, setSelectedValuescontrols_controls] = useState([]);
  const handleSelectChangecontrols_controls = (selectedOptionscontrols_controls) => {
    setSelectedValuescontrols_controls(selectedOptionscontrols_controls);
  };


  const fetchEdit = () => {
    axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/video-player-setting/index`, {
        headers: headers,
      })
      .then((response) => {
        var result = response?.data?.video_player_settings[0];
        if (result) {
          if (result.vertical_enable_like === null || result.vertical_enable_like === undefined) result.vertical_enable_like = 1;
          if (result.vertical_enable_dislike === null || result.vertical_enable_dislike === undefined) result.vertical_enable_dislike = 1;
          if (result.vertical_enable_wishlist === null || result.vertical_enable_wishlist === undefined) result.vertical_enable_wishlist = 1;
          if (result.vertical_enable_follow === null || result.vertical_enable_follow === undefined) result.vertical_enable_follow = 0;
          if (result.vertical_enable_profile === null || result.vertical_enable_profile === undefined) result.vertical_enable_profile = 0;
          if (result.vertical_enable_watch_later === null || result.vertical_enable_watch_later === undefined) result.vertical_enable_watch_later = 1;
          if (result.vertical_enable_comments === null || result.vertical_enable_comments === undefined) result.vertical_enable_comments = 0;
          if (result.vertical_enable_share === null || result.vertical_enable_share === undefined) result.vertical_enable_share = 1;
          if (result.enable_speed_control === null || result.enable_speed_control === undefined) result.enable_speed_control = 0;
          if (result.show_quality_control === null || result.show_quality_control === undefined) result.show_quality_control = 0;
        }
        setPlayerData(result);

        var dataspeed_control = response?.data?.video_player_settings[0]?.show_speed_control;
        const formattedOptionsspeed_control = dataspeed_control?.map((item) => ({
          value: item?.value || JSON.parse(item?.value),
          label: item?.name || JSON.parse(item?.name),
        }));
        setSelectedValuesspeed_control(formattedOptionsspeed_control);
        setOptionsshow_speed_control(formattedOptionsspeed_control);

        const datashow_speed_control = response?.data?.speed_control;
        const formattedOptionsshow_speed_control = datashow_speed_control?.map((item) => ({
          value: item?.value,
          label: item?.name,
        }));
        setOptionsshow_speed_control(formattedOptionsshow_speed_control);

        var datacontrols_controls = response?.data?.video_player_settings[0]?.controls;
        const formattedOptionscontrols_controls = datacontrols_controls?.map((item) => ({
          value: item?.value || JSON.parse(item?.value),
          label: item?.name || JSON.parse(item?.name),
        }));
        setSelectedValuescontrols_controls(formattedOptionscontrols_controls);
        setOptionscontrols(formattedOptionscontrols_controls);

        const datacontrols = response?.data?.controls;
        const formattedOptionscontrols = datacontrols?.filter(item => item.value === 'Speed' || item.value === 'Quality')
          .map(item => ({
            value: item.value,
            label: item.name,
          }));
        setOptionscontrols(formattedOptionscontrols);
      })

      .catch((error) => {
        console.error("Error fetching data from the  API:", error);
      });
  };

  useEffect(async () => {
    fetchEdit();
  }, []);
  useEffect(() => {
    if (onlyPermission) {
      if (onlyPermission.includes(45) && !onlyPermission.includes(49)) {
        setActiveTab("horizontal");
      } else if (onlyPermission.includes(49) && !onlyPermission.includes(45)) {
        setActiveTab("vertical");
      }
    }
  }, [onlyPermission]);
  useEffect(() => {
    if (playerData?.enable_speed_control === 0 || playerData?.enable_speed_control === "0") {
      setSelectedValuesspeed_control([]);
    }
  }, [playerData?.enable_speed_control]);

  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const handleToggle = (e) => {
    const name = e.target.name;
    setPlayerData((prevState) => ({
      ...prevState,
      [name]: prevState[name] === 0 || prevState[name] === null ? 1 : 0,
    }));
  };

  const handleInputChange = (event) => {
    const { name, value, type } = event.target;
    let errorMsg = "";

    if (type === "number" && name === "watermark_opacity") {
      const floatVal = parseFloat(value);
      if (floatVal < 0 || floatVal > 1) {
        errorMsg = "Opacity should be in-between 0 to 1";
      }

      setPlayerData((prevState) => ({
        ...prevState,
        [name]: value,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: errorMsg,
      }));

      return;
    }

    if (type == 'select-one') {
      setPlayerData((prev) => ({
        ...prev,
        [name]: value
      }))
    }

    const urlPattern = /^(https?:\/\/)[a-zA-Z0-9\-]+(\.[a-zA-Z]{2,})(\/.*)?$/;
    if (name === "watermar_link" && value && !urlPattern.test(value)) {
      errorMsg = "Enter a valid link (e.g., http://example.com)";
    }

    setPlayerData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMsg,
    }));
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files;
    setWatermarkLogoError(''); // Reset error message

    if (selectedFile?.length > 0) {
      const newFile = selectedFile[0];
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];

      if (!validTypes.includes(newFile.type)) {
        setWatermarkLogoError('Please select a valid image file (JPEG, JPG, or PNG)');
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        setFileName(newFile);
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(newFile);
    }
  };



  const handleFileChangeplayer_thumbnail = (event) => {
    const selectedFileplayer_thumbnail = event.target.files;
    setPlayerThumbnailError(''); // Reset error message

    if (selectedFileplayer_thumbnail?.length > 0) {
      const newFile = selectedFileplayer_thumbnail[0];
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];

      if (!validTypes.includes(newFile.type)) {
        setPlayerThumbnailError('Please select a valid image file (JPEG, JPG, or PNG)');
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        setFileNameplayer_thumbnail(newFile);
        setPreviewImageplayer_thumbnail(reader.result);
      };
      reader.readAsDataURL(newFile);
    }
  };

  const handleSelectChange = (name, value) => {
    setPlayerData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClearFile = () => {
    setFileName(null);
    setPreviewImage(null);
  };

  const handleClearFileplayer_thumbnail = () => {
    setFileNameplayer_thumbnail(null);
    setPreviewImageplayer_thumbnail(null);
  };

  const handleFileChangePlayerLogo = (event) => {
    const selectedFile = event.target.files;
    setPlayerLogoError('');
    if (selectedFile?.length > 0) {
      const newFile = selectedFile[0];
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!validTypes.includes(newFile.type)) {
        setPlayerLogoError('Please select a valid image file (JPEG, JPG, or PNG)');
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setFileNamePlayerLogo(newFile);
        setPreviewImagePlayerLogo(reader.result);
      };
      reader.readAsDataURL(newFile);
    }
  };

  const handleClearFilePlayerLogo = () => {
    setFileNamePlayerLogo(null);
    setPreviewImagePlayerLogo(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    const urlPattern = /^(https?:\/\/)[a-zA-Z0-9\-]+(\.[a-zA-Z]{2,})(\/.*)?$/;
    const link = playerData.watermar_link?.trim();
    if (link) {
      const urlPattern = /^(https?:\/\/)[a-zA-Z0-9\-]+(\.[a-zA-Z]{2,})(\/.*)?$/;
      if (!urlPattern.test(link)) {
        newErrors.watermar_link = "Enter a valid link (e.g., http://example.com)";
      }
    }

    const opacity = playerData.watermark_opacity?.trim();
    if (opacity !== "") {
      const parsedOpacity = parseFloat(opacity);
      if (isNaN(parsedOpacity) || parsedOpacity < 0 || parsedOpacity > 1) {
        newErrors.watermark_opacity = "Opacity must be between 0 to 1.";
      }
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors((prev) => ({
        ...prev,
        ...newErrors,
      }));
      toast.error("Please fix the errors before submitting.");
      return;
    }
    try {
      setShowOverlay(true);
      const formDatas = {};
      for (const key in playerData) {
        if (key !== 'controls' && key !== 'show_speed_control' && key !== 'player_thumbnail') {
          formDatas[key] = playerData[key];
        }
      }
      formDatas["show_speed_control"] = selectedValuesspeed_control
        ?.map((option) => option?.value)
        .join(", ");
      formDatas["controls"] = selectedValuescontrols_controls
        ?.map((option) => option?.value)
        .join(", ");

      formDatas["watermark"] = playerData?.watermark === 'custom_text' ? playerData?.watermark_custom_text : playerData?.watermark

      const response = await fetchRequest({
        method: 'POST',
        url: `${process.env.REACT_APP_Baseurl}/admin/video-player-setting/store`,
        params: {},
        data: formDatas,
      });

      if (response?.status) {
        if (fileName || fileNameplayer_thumbnail || fileNamePlayerLogo) {
          let formDataForImage = new FormData();
          const imageFields = [];
          formDataForImage.append("id", response?.updated_VideoPlayerSetting?.id);
          formDataForImage.append("modelName", "VideoPlayerSetting");
          if (fileName) {
            formDataForImage.append("watermark_logo", fileName);
            imageFields.push("watermark_logo");
          }
          if (fileNameplayer_thumbnail) {
            formDataForImage.append("player_thumbnail", fileNameplayer_thumbnail);
            imageFields.push("player_thumbnail");
          }
          if (fileNamePlayerLogo) {
            formDataForImage.append("player_logo", fileNamePlayerLogo);
            imageFields.push("player_logo");
          }
          imageFields.forEach((field) => {
            formDataForImage.append('imageFields[]', field);
          });

          await fetchRequest({
            method: 'POST',
            url: globalImageUplaodAPI(),
            params: {},
            data: formDataForImage,
          });
          setFileName(null);
          setPreviewImage(null);
          setFileNameplayer_thumbnail(null);
          setPreviewImageplayer_thumbnail(null);
          setFileNamePlayerLogo(null);
          setPreviewImagePlayerLogo(null);
        }
        fetchEdit();
        setShowOverlay(false);
        toast.success(response?.message);
      }
    } catch (err) {
      setShowOverlay(false);
      console.error(err);
      toast.error(err?.response?.data?.message || err?.message);
    }
  };

  return (
    <>

      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={"Player Settings"} saveText={"Update Player"} saveMethod={handleSubmit} />

      {(onlyPermission?.includes(45) || onlyPermission?.includes(49)) && (
        <div className="iq-card home_mobile mb-3">
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                className={`nav-link ${activeTab === "horizontal" ? "active" : ""}`}
                onClick={() => setActiveTab("horizontal")}
                type="button"
                role="tab"
                aria-selected={activeTab === "horizontal"}
              >
                <h6>Horizontal</h6>
              </button>
              <button
                className={`nav-link ${activeTab === "vertical" ? "active" : ""}`}
                onClick={() => setActiveTab("vertical")}
                type="button"
                role="tab"
                aria-selected={activeTab === "vertical"}
              >
                <h6>Vertical</h6>
              </button>
            </div>
          </nav>
        </div>
      )}

      {activeTab === "horizontal" && (
        <FormContainer>
          <LeftWrapper>

            <Wrapper>
              <MessageHeading text={"Nexus Player Settings"} />
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-8 pe-2">
                  <MessageLabel text={"Enable Nexs Video Player"} />
                </div>
                <div className="col-6 col-md-4 ps-2 text-end">
                  <AdminSwitch
                    name={'nexus_player'}
                    checked={playerData?.nexus_player == 1}
                    onChange={handleToggle}
                  />
                </div>
              </div>

              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-8 pe-2">
                  <MessageLabel text={"Fallback error"} />
                </div>
                <div className="col-6 col-md-4 ps-2 text-end">
                  <AdminSwitch
                    name={'fallback_error'}
                    checked={playerData?.fallback_error == 1}
                    onChange={handleToggle}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-8 pe-2">
                  <MessageLabel text={"Youtube native control"} />
                </div>
                <div className="col-6 col-md-4 ps-2 text-end">
                  <AdminSwitch
                    name={'youtube_native_control'}
                    checked={playerData?.youtube_native_control == 1}
                    onChange={handleToggle}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-8 pe-2">
                  <MessageLabel text={"Player control"} />
                </div>
                <div className="col-6 col-md-4 ps-2 text-end">
                  <AdminSwitch
                    name={'player_controls'}
                    checked={playerData?.player_controls == 1}
                    onChange={handleToggle}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-8 pe-2">
                  <MessageLabel text={"Autoplay"} />
                </div>
                <div className="col-6 col-md-4 ps-2 text-end">
                  <AdminSwitch
                    name={'autoplay'}
                    checked={playerData?.autoplay == 1}
                    onChange={handleToggle}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-8 pe-2">
                  <MessageLabel text={"Enable speed control"} />
                </div>
                <div className="col-6 col-md-4 ps-2 text-end">
                  <AdminSwitch
                    name={'enable_speed_control'}
                    checked={playerData?.enable_speed_control == 1}
                    onChange={handleToggle}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-8 pe-2">
                  <MessageLabel text={"Enable quality"} />
                </div>
                <div className="col-6 col-md-4 ps-2 text-end">
                  <AdminSwitch
                    name={'show_quality_control'}
                    checked={playerData?.show_quality_control == 1}
                    onChange={handleToggle}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <div className="col-6 col-md-8 pe-2">
                  <MessageLabel text={"Player Navigation"} />
                </div>

                <div className="col-6 col-md-4 ps-2 text-end">
                  <AdminCustomSelect name="player_navigation" value={playerData?.player_navigation} onChange={handleInputChange} options={navigationOptions} />
                </div>
              </div>
            </Wrapper>
            {/* <Wrapper>
            <MessageLabel text={"Images"} />
            <MessageLabel text={"Upload Watermark"} />
            <img src={playerData?.watermark_logo} className="editFormImage" />
            <div className="d-flex flex-wrap justify-content-between gap-2">
              <div className="col-sm-5 col-md-12 col-lg-5 col-12 position-relative pb-2">

                <div className="imagedrop mt-1 p-1 position-relative">
                  <input
                    id="watermark_logo"
                    type="file"
                    className={`rs-input form-control-lg opacity-0 h-100 w-100 p-0 m-0 cursor-pointer ${watermarkLogoError ? "is-invalid" : ""
                      }`}
                    name="watermark_logo"
                    accept="image/jpeg, image/jpg, image/png"
                    onChange={handleFileChange}
                    key={fileName || "watermark_input"}
                  />
                  <label htmlFor="watermark_logo" className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
                    <CameraRetroIcon style={{ pointerEvents: "none" }} />
                  </label>

                </div>
                {watermarkLogoError && (
                  <div className="errorred mt-1">
                    {watermarkLogoError}
                  </div>
                )}
              </div>
              {fileName && (
                <div className="col-sm-5 col-12 col-md-12 col-lg-5">
                  <div
                    className="imagedrop  dropzone mt-1 p-1"
                    style={{
                      backgroundImage: `url(${previewImage && previewImage
                        })`,
                    }}
                  >
                    {fileName && (
                      <button
                        type="button"
                        className="btn btn-close"
                        onClick={handleClearFile}
                      ></button>
                    )}
                  </div>
                </div>
              )}
            </div>

            <MessageLabel text={"Thumbnail Image"} />
            <img src={playerData?.player_thumbnail} className="editFormImage" />
            <div className="d-flex flex-wrap justify-content-between gap-2">
              <div className="col-sm-5 col-md-12 col-lg-5 col-12 position-relative pb-2">
                <div className="imagedrop mt-1 p-1 position-relative">
                  <input
                    id="player_thumbnail"
                    type="file"
                    className={`rs-input form-control-lg opacity-0 h-100 w-100 p-0 m-0 ${playerThumbnailError ? "is-invalid" : ""
                      }`}
                    name="player_thumbnail"
                    accept="image/jpeg, image/jpg, image/png"
                    onChange={handleFileChangeplayer_thumbnail}
                    key={fileNameplayer_thumbnail || "thumbnail_input"}
                  />
                  <label htmlFor="player_thumbnail" className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
                    <CameraRetroIcon style={{ pointerEvents: "none" }} />
                  </label>
                </div>
                {playerThumbnailError && (
                  <div className="errorred mt-1">
                    {playerThumbnailError}
                  </div>
                )}
              </div>
              {fileNameplayer_thumbnail && (
                <div className="col-sm-5 col-12 col-md-12 col-lg-5">
                  <div
                    className="imagedrop  dropzone mt-1 p-1"
                    style={{
                      backgroundImage: `url(${previewImageplayer_thumbnail && previewImageplayer_thumbnail
                        })`,
                    }}
                  >
                    {fileNameplayer_thumbnail && (
                      <button
                        type="button"
                        className="btn btn-close"
                        onClick={handleClearFileplayer_thumbnail}
                      ></button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </Wrapper> */}
            <Wrapper>
              <MessageHeading text={"Subtitle option"} />
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={"Subtitle on as Default"} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch name={'enable_subtitle'} checked={playerData?.enable_subtitle == 1} onChange={handleToggle} />
                </div>
              </div>
            </Wrapper>
          </LeftWrapper>
          <RightWrapper>
            <Wrapper>
              <div className="d-flex justify-content-between flex-wrap mb-2">
                <div className="col-6 col-md-10 pe-2">
                  <MessageLabel text={"Skip intro"} />
                  <MessageSubHeading text="Allows end users to skip some portion of the video opening credits" />
                </div>
                <div className="col-6 col-md-2 ps-2 text-end">
                  <AdminSwitch name={'skip_intro'} checked={playerData?.skip_intro == 1} onChange={handleToggle} />
                </div>
              </div>

              <MessageLabel text={"Add Watermark on the player"} />
              <AdminCustomSelect name="watermark" value={playerData?.watermark} onChange={handleInputChange} options={[{ value: "user_id", name: "User Id" }, { value: "user_email", name: "User Email" }, { value: "user_phone", name: "User Phone" }, { value: "custom_text", name: "Custom Text" }]} defaultOptionName={"Select the Watmark Option"} />
              {playerData?.watermark === 'custom_text' && <AdminCustomInput name="watermark_custom_text" value={playerData?.watermark_custom_text} onChange={handleInputChange} placeHolder={"Enter the Custom Text"} />}
              {(playerData?.enable_speed_control === 1 || playerData?.enable_speed_control === "1") && (
                <Select
                  options={optionsshow_speed_control.filter(
                    (option) =>
                      !selectedValuesspeed_control.some(
                        (selected) =>
                          selected.value?.trim() === option.value?.trim()
                      )
                  )}
                  isMulti
                  className="custom-select-multi custom-placeholder theme-text-color"
                  placeholder="Select Playback Speed"
                  onChange={handleSelectChangespeed_control}
                  value={selectedValuesspeed_control}
                />
              )}
              {/* <div className="d-flex justify-content-between mt-3">
              <MessageLabel text={"Other Controls"} />
            </div>
            <div className="mb-4">
              <div className="mt-1">
                <div className="text-dark">
                  <Select
                    options={optionscontrols.filter(
                      (option) =>
                        !selectedValuescontrols_controls.some(
                          (selected) =>
                            selected.value?.trim() === option.value?.trim()
                        )
                    )}
                    isMulti
                    className="custom-select-multi custom-placeholder theme-text-color"
                    placeholder="Select Others Controls"
                    onChange={handleSelectChangecontrols_controls}
                    value={selectedValuescontrols_controls}
                  />
                </div>
              </div>
            </div> */}
            </Wrapper>

            <Wrapper>
              <MessageHeading text={"Logo Player Settings"} />
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={"Show logos on player"} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch name={'show_logo'} checked={Number(playerData?.show_logo) === 1} onChange={handleToggle} />
                </div>
              </div>

              {Number(playerData?.show_logo) === 1 &&
                <>
                  <MessageLabel text={"Player Logo"} />
                  {playerData?.player_logo && !previewImagePlayerLogo && (
                    <img src={playerData?.player_logo} className="editFormImage mb-2" alt="Player Logo" />
                  )}
                  <div className="d-flex flex-wrap justify-content-between gap-2 mb-3">
                    <div className="col-sm-5 col-md-12 col-lg-5 col-12 position-relative pb-2">
                      <div className="imagedrop mt-1 p-1 position-relative">
                        <input
                          id="player_logo"
                          type="file"
                          className={`rs-input form-control-lg opacity-0 h-100 w-100 p-0 m-0 cursor-pointer ${playerLogoError ? "is-invalid" : ""}`}
                          name="player_logo"
                          accept="image/jpeg, image/jpg, image/png"
                          onChange={handleFileChangePlayerLogo}
                          key={fileNamePlayerLogo || "player_logo_input"}
                        />
                        <label htmlFor="player_logo" className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
                          <CameraRetroIcon style={{ pointerEvents: "none" }} />
                        </label>
                      </div>
                      {playerLogoError && <div className="errorred mt-1">{playerLogoError}</div>}
                    </div>
                    {fileNamePlayerLogo && (
                      <div className="col-sm-5 col-12 col-md-12 col-lg-5">
                        <div
                          className="imagedrop dropzone mt-1 p-1"
                          style={{ backgroundImage: `url(${previewImagePlayerLogo})` }}
                        >
                          <button type="button" className="btn btn-close" onClick={handleClearFilePlayerLogo} />
                        </div>
                      </div>
                    )}
                  </div>

                  <FormContainer>
                    <LeftWrapper>
                      <MessageLabel text={"Top"} />
                      <AdminCustomInput type="number" min={0} id="watermark_top" placeHolder={"Enter top watermark"} name="watermark_top" value={playerData?.watermark_top} onChange={handleInputChange} />
                    </LeftWrapper>
                    <RightWrapper>
                      <MessageLabel text={"Bottom"} />
                      <AdminCustomInput type="number" min={0} id="watermark_bottom" placeHolder={"Enter bottom watermark"} name="watermark_bottom" value={playerData?.watermark_bottom} onChange={handleInputChange} />
                    </RightWrapper>
                  </FormContainer>

                  <FormContainer>
                    <LeftWrapper>
                      <MessageLabel text={"Left"} />
                      <AdminCustomInput type="number" min={0} id="watermark_left" placeHolder={"Enter left watermark"} name="watermark_left" value={playerData?.watermark_left} onChange={handleInputChange} />
                    </LeftWrapper>
                    <RightWrapper>
                      <MessageLabel text={"Right"} />
                      <AdminCustomInput type="number" min={0} id="watermark_right" placeHolder={"Enter right watermark"} name="watermark_right" value={playerData?.watermark_right} onChange={handleInputChange} />
                    </RightWrapper>
                  </FormContainer>

                  <FormContainer>
                    <LeftWrapper>
                      <MessageLabel text={"Opacity"} />
                      <AdminCustomInput type="number" min={0} max={1} id="watermark_opacity" placeHolder={"Enter watermark opacity"} name="watermark_opacity" value={playerData?.watermark_opacity} error={errors.watermark_opacity} onChange={handleInputChange} />
                    </LeftWrapper>
                    <RightWrapper>
                      <MessageLabel text={"Width"} className="mt-2" />
                      <AdminCustomInput type="number" min={0} id="watermar_width" placeHolder={"Enter width"} name="watermar_width" value={playerData?.watermar_width} onChange={handleInputChange} />
                    </RightWrapper>
                  </FormContainer>
                </>}
            </Wrapper>
          </RightWrapper>

          <AdminCustomButton saveMethod={handleSubmit} type="button" saveText={"Update Player"} className="ms-auto" loading={showOverlay} />
        </FormContainer>
      )}

      {activeTab === "vertical" && (
        <div className="vertical-settings-wrapper">
          <FormContainer>
            <div className="col-12 px-2">
              <Wrapper>
                <MessageHeading text={"Vertical Player Settings"} />
                <div className="row mt-3">
                  <div className="col-12 col-md-6">
                    <div className="d-flex justify-content-between mb-2 ">
                      <div className="col-6 col-md-8 pe-2">
                        <MessageLabel text={"Enable like"} />
                      </div>
                      <div className="col-6 col-md-4 ps-2 text-end">
                        <AdminSwitch
                          name={'vertical_enable_like'}
                          checked={playerData?.vertical_enable_like == 1}
                          onChange={handleToggle}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="d-flex justify-content-between mb-2 ">
                      <div className="col-6 col-md-8 pe-2">
                        <MessageLabel text={"Enable watch later"} />
                      </div>
                      <div className="col-6 col-md-4 ps-2 text-end">
                        <AdminSwitch
                          name={'vertical_enable_watch_later'}
                          checked={playerData?.vertical_enable_watch_later == 1}
                          onChange={handleToggle}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="d-flex justify-content-between mb-2 ">
                      <div className="col-6 col-md-8 pe-2">
                        <MessageLabel text={"Enable dislike"} />
                      </div>
                      <div className="col-6 col-md-4 ps-2 text-end">
                        <AdminSwitch
                          name={'vertical_enable_dislike'}
                          checked={playerData?.vertical_enable_dislike == 1}
                          onChange={handleToggle}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="d-flex justify-content-between mb-2 ">
                      <div className="col-6 col-md-8 pe-2">
                        <MessageLabel text={"Enable comments"} />
                      </div>
                      <div className="col-6 col-md-4 ps-2 text-end">
                        <AdminSwitch
                          name={'vertical_enable_comments'}
                          checked={playerData?.vertical_enable_comments == 1}
                          onChange={handleToggle}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="d-flex justify-content-between mb-2 ">
                      <div className="col-6 col-md-8 pe-2">
                        <MessageLabel text={"Enable wishlist"} />
                      </div>
                      <div className="col-6 col-md-4 ps-2 text-end">
                        <AdminSwitch
                          name={'vertical_enable_wishlist'}
                          checked={playerData?.vertical_enable_wishlist == 1}
                          onChange={handleToggle}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="d-flex justify-content-between mb-2 ">
                      <div className="col-6 col-md-8 pe-2">
                        <MessageLabel text={"Enable share"} />
                      </div>
                      <div className="col-6 col-md-4 ps-2 text-end">
                        <AdminSwitch
                          name={'vertical_enable_share'}
                          checked={playerData?.vertical_enable_share == 1}
                          onChange={handleToggle}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="d-flex justify-content-between mb-2 ">
                      <div className="col-6 col-md-8 pe-2">
                        <MessageLabel text={"Enable subscriptions (follow)"} />
                      </div>
                      <div className="col-6 col-md-4 ps-2 text-end">
                        <AdminSwitch
                          name={'vertical_enable_follow'}
                          checked={playerData?.vertical_enable_follow == 1}
                          onChange={handleToggle}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="d-flex justify-content-between mb-2 ">
                      <div className="col-6 col-md-8 pe-2">
                        <MessageLabel text={"Enable profile"} />
                      </div>
                      <div className="col-6 col-md-4 ps-2 text-end">
                        <AdminSwitch
                          name={'vertical_enable_profile'}
                          checked={playerData?.vertical_enable_profile == 1}
                          onChange={handleToggle}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Wrapper>
            </div>
            <AdminCustomButton saveMethod={handleSubmit} type="button" saveText={"Update Player"} className="ms-auto" loading={showOverlay} />
          </FormContainer>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  onlyPermission: state.userPermission.onlyPermission
});

export default connect(mapStateToProps)(Player);
